
import React from 'react';

import { Carousel } from 'antd';

import { ILuxuryHome } from '@share/common-types';

import './style.scss';

const SPEED = 2000;
const AUTOPLAY_SPEED = 8000;
const SLIDES_TO_SHOW = 1;
const SLIDES_TO_SCROLL = 1;


interface IProps {
  home: ILuxuryHome;
}

export const LuxuryHomesDetailsImagesCarrousel: React.FC<IProps> = ({ home }) => {

  const images = home?.media?.length ? home?.media?.map(m => m?.url) : [home?.thumb];
  const hasMoreImages = home?.media?.length > 1;
  
  const propsCarousel = {
    dots: false,
    infinite: true,
    arrows: hasMoreImages,
    speed: SPEED,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    autoplay: false,
    autoplaySpeed: AUTOPLAY_SPEED
  };
  
  return (  
    <div className="luxury-homes-details__image">
      <Carousel {...propsCarousel} lazyLoad="ondemand">
        {images.map((img, i) => (
          <img src={img} alt={`${img}`} key={i} className="luxury-homes-details__image-item" />))}
      </Carousel>
    </div>
  );
};
